import { EdgeAcknowledgeAnnouncementRepository } from '@/modules/connect/infra'
import type { AcknowledgeAnnouncement } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeAcknowledgeAnnouncement(): AcknowledgeAnnouncement {
  return new EdgeAcknowledgeAnnouncementRepository(makeSupabaseEdgeHttpClient()).execute
}
